import {ErrorHandler, Inject, Injectable, Injector, NgZone, OnInit, PLATFORM_ID, SecurityContext} from "@angular/core";
import {Store} from '@ngrx/store';
import {setNotification} from '@store/actions/global.actions';
import {isPlatformBrowser} from "@angular/common";
import {DomSanitizer} from "@angular/platform-browser";


/*
export function writeErrorToHTMLIfAppNotInitialized(error: string) {
    let buttonDebug = document.querySelector(".button-bug");
    if (!buttonDebug && error.length > 0) {
        let divConainerError = document.querySelector("#my-error-container");
        if(!divConainerError){
            let divConainerInitialLoading = document.querySelector("#initial-loading");
            divConainerError = document.createElement("div") as HTMLElement;
            divConainerError.id = 'my-error-container';
            divConainerError.classList.add('container', 'p-2-mobile');
            if(divConainerInitialLoading){
                divConainerInitialLoading.innerHTML = '';
                divConainerInitialLoading.appendChild(divConainerError);
            } else {
                document.body.appendChild(divConainerError);
            }

        }
        let divError = document.createElement("div");
        divError.innerHTML = '<div class="error-msg m-3 notification is-danger">' + error + '</div>';
        divConainerError.prepend(divError)

    }
}
*/
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    isBrowser: boolean;
    constructor(
        private injector: Injector,
        private zone: NgZone,
        @Inject(PLATFORM_ID) platformId: Object,
        private sanitizer: DomSanitizer
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    handleError(error: any) {
        // Log original error
        console.error('log error', error);

        // --- SAFARI / CROSS-ORIGIN SCRIPT ERROR HANDLING ---
        if (typeof ErrorEvent !== 'undefined') {
            const errorEvent = error instanceof ErrorEvent
                ? error
                : error?.cause instanceof ErrorEvent
                    ? error.cause
                    : undefined;

            // 1. Wenn es sich um den typischen anonymen Safari "Script error." handelt (mit oder ohne cause-Wrapper):
            const isOpaqueScriptError =
                errorEvent?.message === 'Script error.' ||
                errorEvent?.message === 'Script error' ||
                error?.message?.includes('Script error.') ||
                (typeof error === 'string' && error.includes('Script error'));

            if (isOpaqueScriptError && !errorEvent?.error) {
                console.warn('Safari reported an opaque cross-origin script error.', error);
                return; // Stumm abbrechen, keine UI-Notification anzeigen
            }

            // 2. Nur wenn ein konkretes zugrunde liegendes Error-Objekt im ErrorEvent existiert, entpacken
            if (errorEvent?.error) {
                error = errorEvent.error;
            }
        }

        const store = this.injector.get(Store);

        // Safely extract error string
        const errorString = error ? error.toString().toLowerCase() : '';

        // Prüft auf typische Mismatch- und Chunk-Loading-Fehler
        if (errorString.includes('nextsibling') ||
            errorString.includes('chunkloaderror') ||
            errorString.includes('hydration')) {

            console.warn('Hydration/Cache Fehler erkannt.');

            if (this.isBrowser) {
                const now = Date.now();
                const lastReloadStr = sessionStorage.getItem('last_reload_time');

                if (lastReloadStr && (now - parseInt(lastReloadStr, 10)) < 10000) {
                    console.error('Reload hat nicht geholfen (Endlosschleifen-Schutz aktiv). Breche ab.');
                } else {
                    console.warn('Erzwinge Reload...');
                    sessionStorage.setItem('last_reload_time', now.toString());
                    window.location.reload();
                }
            }
            return;
        }

        // Andere Fehler normal im UI anzeigen
        this.zone.run(() => {
            let errorMsg = '';

            if (error?.name) {
                errorMsg += `<b>${error.name}</b><br>`;
            }
            if (error?.message) {
                errorMsg += `${error.message}<br>`;
            }
            if (error?.stack) {
                errorMsg += `<small>${error.stack}</small>`;
            }

            if (!errorMsg && typeof error === 'string') {
                errorMsg = error;
            }

            store.dispatch(setNotification({ notification: errorMsg, notificationType: 'error' }));
        });
    }
}
